import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<select class={{this.qlClass}} ...attributes>\n  {{#if (has-block)}}\n    {{yield}}\n  {{else}}\n    {{#each @values as |value|}}\n      <option selected={{eq @selected value}} value={{if value value}}></option>\n    {{/each}}\n  {{/if}}\n</select>");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component - tiny presentational <select> for the Quill toolbar,
 *              maps @type to the `ql-<type>` CSS class Quill's toolbar module
 *              looks for
 *   extends:   Component (@glimmer/component)
 *   template:  select.hbs (quill/toolbar/select.hbs)
 *   args:      @type, @values, @selected (rendered in select.hbs's default
 *              {{#each}} branch when no block content is passed)
 *   uses:      -
 *   siblings:  quill/toolbar/button.js, quill/toolbar/group.js, quill/toolbar.js
 *   tests:     select-test.js (unit: tests/unit/components/quill/toolbar/select-test.js;
 *              integration: tests/integration/components/quill/toolbar/select-test.js)
 *   gotchas:   -
 */
class QuillToolbarSelectComponent extends Component {
  get qlClass() {
    if (this.args.type) {
      return `ql-${this.args.type}`;
    }
    return null;
  }
}
setComponentTemplate(TEMPLATE, QuillToolbarSelectComponent);

export { QuillToolbarSelectComponent as default };
//# sourceMappingURL=select.js.map
